/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Container, MoviesDatesFilter, NoContent } from "app/components";
import {
  ListEntity,
  ListEntityItem,
  ListEntityFigure,
  ListEntityInner,
  SectionEntities,
  getEventDates
} from "app/components/Entity";
import { WithEventsWatchlistBtn, ButtonWatchlist } from "app/modules/watchlist";
import { dateValidator } from "app/utils";
import { useUtils, useConfig } from "app/hooks";
import { format } from "date-fns";
import { BEFORE_ROUTE_TRANSITION } from "app/HOC/withRouteEvents";

const WatchListBtn = WithEventsWatchlistBtn(ButtonWatchlist);

const filterParameters = parameters => {
  return Object.keys(parameters).reduce((newParameters, property) => {
    const actualValue = parameters[property];

    return actualValue === "all"
      ? newParameters
      : {
          ...newParameters,
          [property]: actualValue
        };
  }, {});
};

const propTypes = {
  history: PropTypes.shape({
    location: PropTypes.shape({
      search: PropTypes.string
    }).isRequired,

    replace: PropTypes.func.required
  }).isRequired,

  events: PropTypes.arrayOf(PropTypes.object).isRequired,
  dates: PropTypes.arrayOf(PropTypes.string).isRequired,
  storeDate: PropTypes.string,
  locations: PropTypes.arrayOf(PropTypes.object).isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  savedLocation: PropTypes.string.isRequired,

  clearErrorApi: PropTypes.func.isRequired,
  getAllEvents: PropTypes.func.isRequired,
  setStoreDate: PropTypes.func.isRequired,

  saveLocation: PropTypes.func.isRequired,
  resetState: PropTypes.func.isRequired
};

const defaultProps = {
  storeDate: null
};

const AllEvents = ({
  history,

  events,
  dates,
  storeDate,
  locations,
  isLoggedIn,
  savedLocation,
  clearErrorApi,
  getAllEvents,
  setStoreDate,
  saveLocation,
  resetState
}) => {
  const [t] = useTranslation();
  const urlSearchParams = new URLSearchParams(history.location.search);
  const cinemasLocation = urlSearchParams.get("location");
  const date = storeDate || urlSearchParams.get("date");
  const isDateValid = date === "all" || dateValidator(date);
  const [redLabelLocation, setRedLabelLocation] = useState(false);
  const [redLabelDate, setRedLabelDate] = useState(false);
  const { getDateWithOffset, getFallbackDate } = useUtils();
  const { routes } = useConfig();

  useEffect(() => {
    const listener = ({
      detail: {
        nextLocation: { pathname }
      }
    }) => {
      if (
        pathname !== routes.movies.pattern &&
        pathname !== routes.no_internet.pattern
      ) {
        setStoreDate(null);
      }
    };

    if (process.env.REACT_APP_COUNTRY === "svn") {
      document.title = "Cineplexx | Dogodki";
    }

    window.addEventListener(BEFORE_ROUTE_TRANSITION, listener, false);

    return () => {
      window.removeEventListener(BEFORE_ROUTE_TRANSITION, listener, false);
      clearErrorApi();
      resetState();
      document.title = "Cineplexx";
    };
  }, []);

  const data = events.map(item => {
    return { id: item.id, eventUrlName: item.eventUrlName };
  });

  localStorage.setItem("events", JSON.stringify(data));

  useEffect(() => {
    let correctedLocation = null;
    const locationToCheck = cinemasLocation || savedLocation;

    if (!locations.length) {
      return;
    }

    if (
      locations.length &&
      !locations.some(l => l.id.toString() === locationToCheck) &&
      locationToCheck !== "all"
    ) {
      saveLocation("all");
      correctedLocation = "all";
      urlSearchParams.set("location", "all");
      history.replace({ search: `?${urlSearchParams.toString()}` });
    }

    if (!cinemasLocation) {
      urlSearchParams.set("location", correctedLocation || savedLocation);
      history.replace({ search: `?${urlSearchParams.toString()}` });
    }

    const params = filterParameters({
      location: locationToCheck,
      date: isDateValid ? date : "all"
    });

    getAllEvents(params);
  }, [locations]);

  useEffect(() => {
    let fallBackDate = date;
    const isDateExist =
      !dates.length ||
      date === "all" ||
      dates.some(d => format(getDateWithOffset(d), "yyyy-MM-dd") === date);

    if (!isDateValid || !isDateExist) {
      fallBackDate = getFallbackDate(dates);
      // urlSearchParams.set("date", fallBackDate);
      urlSearchParams.set("date", "all");

      setStoreDate(fallBackDate);

      history.replace({
        search: `?${urlSearchParams.toString()}`
      });
    }

    if (isDateValid && !isDateExist) {
      const params = filterParameters({ date: fallBackDate });

      getAllEvents(params);
    }

    if (isDateValid && isDateExist && !storeDate) {
      setStoreDate(date);
    }
  }, [date, dates, isDateValid, urlSearchParams]);

  const onSelectDate = useCallback(
    valueFromSelect => {
      if (!valueFromSelect || !valueFromSelect.length) return;

      const { value, label } = valueFromSelect[0];
      const selectedLocation = urlSearchParams.get("location");
      const isDateExist =
        !dates.length ||
        value === "all" ||
        dates.some(d => format(getDateWithOffset(d), "yyyy-MM-dd") === value);

      setRedLabelDate(
        label !== t("common.today") && label !== t("common.all_months")
      );

      if (
        !value ||
        urlSearchParams.get("date") === value.toString() ||
        !isDateExist
      ) {
        return;
      }

      setStoreDate(value);
      urlSearchParams.set("date", value);
      history.replace({ search: `?${urlSearchParams.toString()}` });

      const params = filterParameters({
        location: selectedLocation,
        date: value
      });

      getAllEvents(params);
    },
    [urlSearchParams, dates, setStoreDate]
  );

  const onSelectLocation = useCallback(
    valueFromSelect => {
      if (!valueFromSelect || !valueFromSelect.length) return;

      const { value } = valueFromSelect[0];
      const selectedDate = urlSearchParams.get("date");

      setRedLabelLocation(value !== "all");

      if (
        value.toString() === urlSearchParams.get("location") &&
        value.toString() === savedLocation
      ) {
        return;
      }

      saveLocation(value);
      urlSearchParams.set("location", value);
      history.replace({ search: `?${urlSearchParams.toString()}` });

      const params = filterParameters({ location: value, date: selectedDate });

      getAllEvents(params);
    },
    [urlSearchParams, savedLocation]
  );

  useEffect(() => {
    localStorage.removeItem("eventId");
    sessionStorage.removeItem("seletEventMovieId");
    localStorage.removeItem("searchMovieId");
    sessionStorage.removeItem("cinemaId");
    localStorage.removeItem("selectMovieId");
  });

  return (
    <SectionEntities noPadding>
      <div className="fixed-event-all-detail">
        <Container>
          <MoviesDatesFilter
            locations={locations}
            selectedLocation={cinemasLocation || savedLocation}
            onSelectLocation={onSelectLocation}
            redLabelLocation={redLabelLocation}
            /* eslint-disable-next-line */
            dates={dates.length ? dates : date === "all" ? [] : [date]}
            selectedDate={date}
            onSelectDate={onSelectDate}
            redLabelDate={redLabelDate}
            isAsMonths
          />
        </Container>
      </div>
      <Container>
        <div className="event-list">
          {events.length ? (
            <ListEntity>
              {events.map(event => {
                // const to = {
                //   pathname: generatePath(routes.eventDetails.pattern, {
                //     id: event.title.replaceAll(' ', '-')
                //   }),
                //   state: { eventId: event.id }
                // };
                const subTitle = getEventDates(
                  event.startDate,
                  event.endDate,
                  getDateWithOffset
                );

                return (
                  <ListEntityItem
                    key={event?.id}
                    onClick={() =>
                      localStorage.setItem(
                        "eventId",
                        JSON.stringify(event?.eventUrlName)
                      )
                    }
                  >
                    <ListEntityFigure>
                      <ListEntityInner
                        title={event.title}
                        poster={event.poster}
                        to={event}
                        subTitle={subTitle}
                      />
                      {isLoggedIn ? (
                        <WatchListBtn
                          id={event.id}
                          isInWatchList={event.isInWatchlist}
                        />
                      ) : null}
                    </ListEntityFigure>
                  </ListEntityItem>
                );
              })}
            </ListEntity>
          ) : (
            <NoContent svgId="no-movies" text={t("movies.no_events")} />
          )}
        </div>
      </Container>
    </SectionEntities>
  );
};

AllEvents.propTypes = propTypes;
AllEvents.defaultProps = defaultProps;
export default AllEvents;
